import React, { useState } from 'react';

const Disclaimer = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    // Premium frosted-glass banner at the very top
    <div className="relative z-50 bg-glass-white backdrop-blur-xl border-b border-white/20 shadow-glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 flex-1">
            {/* Warning icon with glassmorphism */}
            <div className="flex-shrink-0 p-1.5 bg-yellow-400/20 backdrop-blur-lg rounded-full border border-yellow-300/30">
              <svg className="w-4 h-4 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            
            {/* Disclaimer text */}
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm text-neutral-600 font-medium leading-tight">
                <span className="font-semibold text-neutral-700">Medical Disclaimer:</span>{' '}
                <span className="hidden sm:inline">
                  These insights are for informational purposes only and do not constitute medical advice. 
                  Always consult with qualified healthcare professionals for medical decisions.
                </span>
                <span className="sm:hidden">
                  For informational purposes only. Consult healthcare professionals for medical advice.
                </span>
              </p>
            </div>
          </div>

          {/* Dismiss button */}
          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 ml-3 p-1 rounded-full text-neutral-400 hover:text-neutral-600 hover:bg-glass-white transition-all duration-200 group"
            aria-label="Dismiss disclaimer"
          >
            <svg className="w-4 h-4 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Subtle gradient border at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
    </div>
  );
};

export default Disclaimer;